import styled from 'styled-components';
import { COLORS } from '../../colors';

const StyledPricing = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  display: flex;
  flex-direction: column;
  gap: 6rem;

  .bundles {
    display: flex;
    flex-direction: row;
    max-width: 1000px;

    //only smartphone
    @media only screen and (max-width: 600px) {
      flex-direction: column;
    }

    gap: 2rem;

    .bundle {
      border: 1px solid ${COLORS.mainGray};
      padding: 1rem;
      border-radius: 12px;
      flex: 1; 
      max-width: 350px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .affiliateDiscountActive {
        font-size: 14px;
        color: ${COLORS.primary};
        font-weight: bold;
        margin-top: 1rem;
      }

      h1 {
        padding-bottom: 0.5rem;
      }

      p {
        margin-bottom: 1rem;
        b {
          font-size: 20px;
          text-decoration: underline;
        }
      }

      button {
        s {
          padding: 0 5px;
          color: ${COLORS.primary};
        }
      }

      button#free {
        background-color: ${COLORS.primary};
      }
      button#free:disabled {
        background-color: ${COLORS.darkGray};
      }
    }
  }

  .promo {
    background-color: ${COLORS.darkBlueAlternative};
    width: 100%;
    padding: 2rem;
    input {
      margin-top: 1rem;
      margin-bottom: 1rem;
      padding: 1rem;
      border: none;
    }
    button {
      margin: auto;
    }
  }

  .license {
    h1 {
      padding-bottom: 1rem;
    }
    p {
      margin-bottom: 0.5rem;
    }
  }
`

export {
  StyledPricing
}